export default __webpack_public_path__ + "static/media/select-bet-1.f76640a0.mp3";